import { computed, input, linkedSignal, output } from '@angular/core';
import { Marked } from 'marked';
import { AGENT_MARKDOWN_RENDERER_OPTIONS, INCOMPLETE_MARKDOWN_LINK_REGEX, } from 'AgentApp/ts/constants/agent-markdown.constants';
import { IconModule } from 'Angular/features/directives/icon/icon.module';
import * as i0 from "@angular/core";
import * as i1 from "../../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
const _forTrack0 = ($index, $item) => $item.url;
function AgentStepsComponent_Conditional_0_For_7_Conditional_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 9);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const step_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("href", step_r3.url, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(step_r3.title);
} }
function AgentStepsComponent_Conditional_0_For_7_Conditional_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtext(0);
} if (rf & 2) {
    const step_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵtextInterpolate1(" ", step_r3.title, " ");
} }
function AgentStepsComponent_Conditional_0_For_7_Conditional_4_Conditional_0_For_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 13)(1, "div", 15)(2, "div", 16)(3, "div", 17)(4, "div", 18);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(5, "svg", 19);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(6, "div", 20);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd()()()()();
} if (rf & 2) {
    const item_r4 = ctx.$implicit;
    i0.ɵɵproperty("href", item_r4.url, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(7);
    i0.ɵɵtextInterpolate(item_r4.title);
} }
function AgentStepsComponent_Conditional_0_For_7_Conditional_4_Conditional_0_Conditional_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 14);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const step_r3 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("+", step_r3.hiddenItemCount, " more");
} }
function AgentStepsComponent_Conditional_0_For_7_Conditional_4_Conditional_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵrepeaterCreate(1, AgentStepsComponent_Conditional_0_For_7_Conditional_4_Conditional_0_For_2_Template, 8, 2, "a", 13, _forTrack0);
    i0.ɵɵconditionalCreate(3, AgentStepsComponent_Conditional_0_For_7_Conditional_4_Conditional_0_Conditional_3_Template, 2, 1, "span", 14);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const step_r3 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵrepeater(step_r3.visibleItems);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(step_r3.hiddenItemCount ? 3 : -1);
} }
function AgentStepsComponent_Conditional_0_For_7_Conditional_4_Conditional_1_For_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 21)(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(3, "svg", 22);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r5 = ctx.$implicit;
    i0.ɵɵproperty("href", item_r5.url, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r5.title);
} }
function AgentStepsComponent_Conditional_0_For_7_Conditional_4_Conditional_1_Conditional_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 14);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const step_r3 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("+", step_r3.hiddenItemCount, " more");
} }
function AgentStepsComponent_Conditional_0_For_7_Conditional_4_Conditional_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵrepeaterCreate(1, AgentStepsComponent_Conditional_0_For_7_Conditional_4_Conditional_1_For_2_Template, 4, 2, "a", 21, _forTrack0);
    i0.ɵɵconditionalCreate(3, AgentStepsComponent_Conditional_0_For_7_Conditional_4_Conditional_1_Conditional_3_Template, 2, 1, "span", 14);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const step_r3 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵrepeater(step_r3.visibleItems);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(step_r3.hiddenItemCount ? 3 : -1);
} }
function AgentStepsComponent_Conditional_0_For_7_Conditional_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵconditionalCreate(0, AgentStepsComponent_Conditional_0_For_7_Conditional_4_Conditional_0_Template, 4, 1, "div", 11)(1, AgentStepsComponent_Conditional_0_For_7_Conditional_4_Conditional_1_Template, 4, 1, "div", 12);
} if (rf & 2) {
    const step_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵconditional(step_r3.visibleItems[0].kind === "file" ? 0 : 1);
} }
function AgentStepsComponent_Conditional_0_For_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 7)(1, "div", 8);
    i0.ɵɵconditionalCreate(2, AgentStepsComponent_Conditional_0_For_7_Conditional_2_Template, 2, 2, "a", 9)(3, AgentStepsComponent_Conditional_0_For_7_Conditional_3_Template, 1, 1);
    i0.ɵɵelementEnd();
    i0.ɵɵconditionalCreate(4, AgentStepsComponent_Conditional_0_For_7_Conditional_4_Template, 2, 1);
    i0.ɵɵelement(5, "div", 10);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const step_r3 = ctx.$implicit;
    const ɵ$index_13_r6 = ctx.$index;
    const ɵ$count_13_r7 = ctx.$count;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵclassProp("complete", !ctx_r1.streaming() || !(ɵ$index_13_r6 === ɵ$count_13_r7 - 1));
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(step_r3.url ? 2 : 3);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(step_r3.visibleItems.length ? 4 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", step_r3.descriptionHtml, i0.ɵɵsanitizeHtml);
} }
function AgentStepsComponent_Conditional_0_Conditional_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 6)(1, "div", 23);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(2, "svg", 24);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(3, "div", 8);
    i0.ɵɵtext(4, "Done");
    i0.ɵɵelementEnd()();
} }
function AgentStepsComponent_Conditional_0_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 0);
    i0.ɵɵlistener("click", function AgentStepsComponent_Conditional_0_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.toggleSteps()); });
    i0.ɵɵelementStart(1, "div", 1);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "div", 2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 3)(5, "ul", 4);
    i0.ɵɵrepeaterCreate(6, AgentStepsComponent_Conditional_0_For_7_Template, 6, 5, "li", 5, i0.ɵɵrepeaterTrackByIndex);
    i0.ɵɵconditionalCreate(8, AgentStepsComponent_Conditional_0_Conditional_8_Template, 5, 0, "li", 6);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵattribute("aria-expanded", ctx_r1.showSteps());
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.showSteps() ? "Hide Details" : "See Details");
    i0.ɵɵadvance(2);
    i0.ɵɵclassProp("collapse", !ctx_r1.showSteps())("show", ctx_r1.showSteps())("mb-2", ctx_r1.showSteps());
    i0.ɵɵadvance(2);
    i0.ɵɵrepeater(ctx_r1.renderedSteps());
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(!ctx_r1.streaming() && ctx_r1.turnComplete() ? 8 : -1);
} }
const marked = new Marked({ renderer: { ...AGENT_MARKDOWN_RENDERER_OPTIONS } });
const MAX_VISIBLE_STEP_ITEMS = 5;
export class AgentStepsComponent {
    constructor() {
        this.steps = input.required(...(ngDevMode ? [{ debugName: "steps" }] : []));
        this.streaming = input(false, ...(ngDevMode ? [{ debugName: "streaming" }] : []));
        /**
         * Whether the agent turn these steps belong to has finished. Steps flushed onto a message while the
         * response is still streaming are complete themselves, but the run isn't, so no "Done" row yet
         */
        this.turnComplete = input(true, ...(ngDevMode ? [{ debugName: "turnComplete" }] : []));
        this.expanded = input(true, ...(ngDevMode ? [{ debugName: "expanded" }] : []));
        this.toggled = output();
        this.showSteps = linkedSignal(() => this.expanded(), ...(ngDevMode ? [{ debugName: "showSteps" }] : []));
        // Thinking blocks can contain markdown, so render their description as HTML the same way
        // assistant text blocks do (see AgentResponseMessageComponent). tool_call steps carry no
        // description, so this only affects "Thought" steps.
        this.renderedSteps = computed(() => this.steps().map((step) => {
            const items = step.items ?? [];
            return {
                ...step,
                visibleItems: items.slice(0, MAX_VISIBLE_STEP_ITEMS),
                hiddenItemCount: Math.max(0, items.length - MAX_VISIBLE_STEP_ITEMS),
                descriptionHtml: step.description
                    ? marked.parse(step.description.replace(INCOMPLETE_MARKDOWN_LINK_REGEX, '*Creating Link...*'))
                    : '',
            };
        }), ...(ngDevMode ? [{ debugName: "renderedSteps" }] : []));
    }
    toggleSteps() {
        const next = !this.showSteps();
        this.showSteps.set(next);
        this.toggled.emit(next);
    }
}
AgentStepsComponent.ɵfac = function AgentStepsComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AgentStepsComponent)(); };
AgentStepsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AgentStepsComponent, selectors: [["ycn-agent-steps"]], inputs: { steps: [1, "steps"], streaming: [1, "streaming"], turnComplete: [1, "turnComplete"], expanded: [1, "expanded"] }, outputs: { toggled: "toggled" }, decls: 1, vars: 1, consts: [["role", "button", "aria-controls", "agentStepsDetails", 1, "btn", "btn-transparent-rounded", "mb-2", 3, "click"], [1, "text-thin"], [1, "collapse-chevron", "align-self-center"], ["id", "agentStepsDetails"], [1, "list-steps"], [1, "list-steps-item", 3, "complete"], [1, "list-steps-item", "has-icon", "complete"], [1, "list-steps-item"], [1, "list-steps-title"], ["target", "_blank", 1, "text-underline", "text-blue", 3, "href"], [1, "list-steps-description", 3, "innerHTML"], [1, "d-flex", "flex-wrap", "align-items-center"], [1, "d-flex", "flex-wrap", "align-items-center", "gap-1"], ["target", "_blank", 1, "plate-container", "d-inline-flex", 3, "href"], [1, "text-small", "text-gray-60"], [1, "plate", "plate-thin", "plate-noshadow", "plate-white"], [1, "plate-header", "width-full"], [1, "plate-title", "min-width-0"], [1, "plate-title-icon"], ["ycnIcon", "", "name", "icon-overview"], [1, "plate-title-name", "min-width-0", "text-ellipsis"], ["target", "_blank", 1, "text-small", "text-blue", "d-inline-flex", "align-items-center", 3, "href"], ["ycnIcon", "", "name", "icon-export", 1, "ml-1", "fill-current"], [1, "list-steps-item-icon"], ["ycnIcon", "", "name", "icon-check-circle", 1, "text-green", "fill-current"]], template: function AgentStepsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵconditionalCreate(0, AgentStepsComponent_Conditional_0_Template, 9, 9);
    } if (rf & 2) {
        i0.ɵɵconditional(ctx.steps().length > 0 ? 0 : -1);
    } }, dependencies: [IconModule, i1.IconDirective], encapsulation: 2, changeDetection: 0 });
